import mainTranslate from 'loankeeper-common/helpers/language'
import { formName } from './constants'

export const translate = (key: string): string => mainTranslate(formName, key)
